import { call, put, takeLatest } from "redux-saga/effects";
import {
  RAG_ACTION_TYPES,
  processDocumentSuccess,
  processDocumentFailure,
  queryRAGSuccess,
  queryRAGFailure,
  getDocumentSuccess,
  getDocumentFailure,
  listDocumentsSuccess,
  listDocumentsFailure,
  getDocumentChunksSuccess,
  getDocumentChunksFailure,
  getRAGStatsSuccess,
  getRAGStatsFailure,
  updateDocumentSuccess,
  updateDocumentFailure,
  deleteDocumentSuccess,
  deleteDocumentFailure,
} from "../actions/ragActions";
import {
  processDocument as processDocumentApi,
  queryRAG as queryRAGApi,
  getDocument as getDocumentApi,
  listDocuments as listDocumentsApi,
  getDocumentChunks as getDocumentChunksApi,
  getRAGStats as getRAGStatsApi,
  updateDocument as updateDocumentApi,
  deleteDocument as deleteDocumentApi,
} from "../apis/ragApi";

// Process Document Saga
function* processDocumentSaga(action) {
  try {
    console.log("RAG Saga - processDocumentSaga - action:", action);

    const response = yield call(processDocumentApi, action.payload);

    console.log("RAG Saga - processDocumentSaga - response:", response);

    if (response && response.success) {
      yield put(processDocumentSuccess(response));
    } else {
      yield put(
        processDocumentFailure(response?.error || "Document processing failed")
      );
    }
  } catch (error) {
    console.error("RAG Saga - processDocumentSaga - error:", error);
    yield put(processDocumentFailure(error.message));
  }
}

// Query RAG Saga
function* queryRAGSaga(action) {
  try {
    console.log("RAG Saga - queryRAGSaga - action:", action);

    const response = yield call(queryRAGApi, action.payload);

    console.log("RAG Saga - queryRAGSaga - response:", response);

    if (response && response.success) {
      yield put(queryRAGSuccess(response));
    } else {
      yield put(queryRAGFailure(response?.error || "RAG query failed"));
    }
  } catch (error) {
    console.error("RAG Saga - queryRAGSaga - error:", error);
    yield put(queryRAGFailure(error.message));
  }
}

// Get Document Saga
function* getDocumentSaga(action) {
  try {
    console.log("RAG Saga - getDocumentSaga - action:", action);

    const { documentId, tenantId } = action.payload;
    const response = yield call(getDocumentApi, documentId, tenantId);

    console.log("RAG Saga - getDocumentSaga - response:", response);

    if (response) {
      yield put(getDocumentSuccess(response));
    } else {
      yield put(getDocumentFailure("Document fetch failed"));
    }
  } catch (error) {
    console.error("RAG Saga - getDocumentSaga - error:", error);
    yield put(getDocumentFailure(error.message));
  }
}

// List Documents Saga
function* listDocumentsSaga(action) {
  try {
    console.log("RAG Saga - listDocumentsSaga - action:", action);

    const { tenantId, status, limit } = action.payload;
    const response = yield call(listDocumentsApi, tenantId, status, limit);

    console.log("RAG Saga - listDocumentsSaga - response:", response);

    if (response) {
      yield put(listDocumentsSuccess(response));
    } else {
      yield put(listDocumentsFailure("Documents list fetch failed"));
    }
  } catch (error) {
    console.error("RAG Saga - listDocumentsSaga - error:", error);
    yield put(listDocumentsFailure(error.message));
  }
}

// Get Document Chunks Saga
function* getDocumentChunksSaga(action) {
  try {
    console.log("RAG Saga - getDocumentChunksSaga - action:", action);

    const { documentId, tenantId } = action.payload;
    const response = yield call(getDocumentChunksApi, documentId, tenantId);

    console.log("RAG Saga - getDocumentChunksSaga - response:", response);

    if (response) {
      yield put(getDocumentChunksSuccess(response));
    } else {
      yield put(getDocumentChunksFailure("Document chunks fetch failed"));
    }
  } catch (error) {
    console.error("RAG Saga - getDocumentChunksSaga - error:", error);
    yield put(getDocumentChunksFailure(error.message));
  }
}

// Get RAG Stats Saga
function* getRAGStatsSaga(action) {
  try {
    console.log("RAG Saga - getRAGStatsSaga - action:", action);

    const { tenantId } = action.payload;
    const response = yield call(getRAGStatsApi, tenantId);

    console.log("RAG Saga - getRAGStatsSaga - response:", response);

    if (response) {
      yield put(getRAGStatsSuccess(response));
    } else {
      yield put(getRAGStatsFailure("RAG stats fetch failed"));
    }
  } catch (error) {
    console.error("RAG Saga - getRAGStatsSaga - error:", error);
    yield put(getRAGStatsFailure(error.message));
  }
}

// Update Document Saga
function* updateDocumentSaga(action) {
  try {
    console.log("RAG Saga - updateDocumentSaga - action:", action);

    const response = yield call(updateDocumentApi, action.payload);

    console.log("RAG Saga - updateDocumentSaga - response:", response);

    if (response && response.success) {
      yield put(updateDocumentSuccess(response));
    } else {
      yield put(
        updateDocumentFailure(response?.error || "Document update failed")
      );
    }
  } catch (error) {
    console.error("RAG Saga - updateDocumentSaga - error:", error);
    yield put(updateDocumentFailure(error.message));
  }
}

// Delete Document Saga
function* deleteDocumentSaga(action) {
  try {
    console.log("RAG Saga - deleteDocumentSaga - action:", action);

    const { documentId, tenantId } = action.payload;
    const response = yield call(deleteDocumentApi, documentId, tenantId);

    console.log("RAG Saga - deleteDocumentSaga - response:", response);

    if (response && response.success) {
      yield put(deleteDocumentSuccess(response));
    } else {
      yield put(
        deleteDocumentFailure(response?.error || "Document deletion failed")
      );
    }
  } catch (error) {
    console.error("RAG Saga - deleteDocumentSaga - error:", error);
    yield put(deleteDocumentFailure(error.message));
  }
}

// RAG Saga Watcher
export function* ragSaga() {
  yield takeLatest(
    RAG_ACTION_TYPES.PROCESS_DOCUMENT_REQUEST,
    processDocumentSaga
  );
  yield takeLatest(RAG_ACTION_TYPES.QUERY_RAG_REQUEST, queryRAGSaga);
  yield takeLatest(RAG_ACTION_TYPES.GET_DOCUMENT_REQUEST, getDocumentSaga);
  yield takeLatest(RAG_ACTION_TYPES.LIST_DOCUMENTS_REQUEST, listDocumentsSaga);
  yield takeLatest(
    RAG_ACTION_TYPES.GET_DOCUMENT_CHUNKS_REQUEST,
    getDocumentChunksSaga
  );
  yield takeLatest(RAG_ACTION_TYPES.GET_RAG_STATS_REQUEST, getRAGStatsSaga);
  yield takeLatest(
    RAG_ACTION_TYPES.UPDATE_DOCUMENT_REQUEST,
    updateDocumentSaga
  );
  yield takeLatest(
    RAG_ACTION_TYPES.DELETE_DOCUMENT_REQUEST,
    deleteDocumentSaga
  );
}
